<template>
  <div v-if="alert">
    <page-header header="Alert">
      <button
        class="d-flex d-md-none btn btn-primary"
        @click="sendTest"
      >
        Send test email
      </button>
      <button
        class="d-none d-md-flex btn btn-primary"
        @click="previewEmail"
      >
        Preview email
      </button>
      <dropdown
        class="d-none d-md-block no-chev"
        alignment="right"
        trigger="click"
      >
        <button slot="trigger" class="ml-2 btn btn-outline-primary btn--more">
          <icon icon="more-vertical" />
        </button>
        <dropdown-option
          class="page-header-dropdown-option"
          @click.native="$modal.show('send-test')"
        >
          <icon
            class="mr-1"
            icon="sent"
          />
          Send test
        </dropdown-option>
      </dropdown>
    </page-header>

    <div
      v-if="alert.sent_at"
      class="row mt-3"
    >
      <div class="col-12 col-md-3 pad-bottom-1 pr-0">
        <div class="h-100 p-3">
          <span style="color: #101820;font-size: 18px">Subject:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ alert.subject }}
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 pad-bottom-1 pr-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">From name:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ alert.from_name || 'Tellimer Alerts' }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 pad-bottom-1 pad-right-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">From email:</span>
          <div
            style="font-weight: 200; font-size: 16px;"
          >
            {{ alert.from_email || 'alerts@tellimer.com' }}
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 pad-bottom-1 pad-right-0">
        <div class="h-100 p-3">
          <span style="color: #101820; font-size: 18px;">
            <span v-if="alert.sent_at">Sent at:</span>
            <span v-else>Sending at:</span>
          </span>
          <div v-date="{ date: alert.sent_at ? alert.sent_at : alert.send_at, format: $settings.dateTimeFormat }" />
        </div>
      </div>
    </div>

    <div
      v-if="$login.canAnalytics() && alert.sent_at"
      class="border-top analytics"
    >
      <analytics
        :data="alert"
      />
    </div>

    <div v-else>
      <tabs ref="tabs">
        <tab name="Edit">
          <edit-form
            v-if="alert"
            ref="edit"
            v-model="alert"
            @save-success="saveSuccess"
          />

          <div class="w-100 py-3 d-flex border-top">
            <button
              v-if="alert.id && $login.can('alerts.delete')"
              type="button"
              class="btn  btn-outline-danger mr-auto"
              @click="$modal.show('confirm-delete')"
            >
              Delete
            </button>

            <!-- <div
              v-if="alert.alertable_type === 'App\\Models\\Article'"
              class="w-100 text-center align-self-center"
            >
              {{ recipients }} recipients
            </div> -->

            <button
              v-if="!articleIsScheduled"
              class="btn btn-outline-primary"
              @click="$refs.edit.sendNow()"
            >
              Save &amp; send now
            </button>

            <button
              class="btn btn-primary  ml-3"
              @click="$refs.edit.save()"
            >
              Save
            </button>
          </div>
        </tab>
        <tab
          v-if="alert.alertable_type === 'App\\Models\\Article'"
          name="Recipients"
          :suffix="recipientsBadge"
          class="pt-3"
        >
          <distribution
            :alert="alert"
            @recipients="(r) => recipients = r"
          />
        </tab>
      </tabs>
    </div>

    <div
      v-if="alert.sent_at"
      class="border-top mt-4"
    >
      <distribution
        :alert="alert"
        @recipients="(r) => recipients = r"
      />
    </div>


    <confirm
      v-if="alert.id"
      @confirmed="deleteAlert"
      :name="alert.subject"
    />

    <html-preview ref="htmlPreview" />
    <send-test
      v-if="alert"
      :article-id="alert.id"
      type="alert"
    />
  </div>
</template>

<script>
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import SendTest from './SendTest'
import Date from '@/directives/date'
import Analytics from './Analytics'
import {successNotification} from '@/notifications'
import HtmlPreview from '@/components/HtmlPreview'
import Distribution from './Distribution'
import EditForm from './Form'
import Confirm from '@/components/Confirm'
import gateway from '@/gateway'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  components: {
    Dropdown,
    DropdownOption,
    SendTest,
    Analytics,
    Confirm,
    HtmlPreview,
    Tab,
    Tabs,
    EditForm,
    Distribution,
  },

  directives: {
    Date,
  },

  metaInfo () {
    return {
      title: this.alert && this.alert.subject ? this.alert.subject : 'Alert',
    }
  },

  data () {
    return {
      alert: null,
      loading: false,
      emailHtml: null,
      recipients: 0,
    }
  },

  computed: {
    canEdit () {
      return this.$login.can('alerts.update')
    },

    recipientsBadge () {
      return `<span class="ml-2 badge badge-tellimer">${this.recipients}</span>`
    },

    articleIsScheduled () {
      return this.alert.alertable.is_scheduled
    }
  },

  async created () {
    const {data} = await this.$http.get(`alerts/${this.$route.params.alertId}`)
    this.setAlert(data.data)
  },

  methods: {
    setAlert (alert) {
      this.alert = alert
    },

    saveSuccess (response) {
      this.$notify(successNotification('Updated alert'))
      this.$router.go(-1)
    },


    async deleteAlert () {
      try {
        await this.$http.delete(`/alerts/${this.alert.id}`)
        this.$notify(successNotification(`Deleted alert ${this.alert.id}`))
        this.$router.go(-1)
      } catch (e) {
        console.log(e)
      }
    },

    previewEmail () {
      this.$refs.htmlPreview.preview('alerts', this.alert.id)
    },

    async sendTest () {
      const users = [this.$login.getUser()]
      const url = `/alerts/${this.alert.id}/test`

      await gateway.post(url, {users})
      this.$notify(successNotification('Email sent!'))
    },
  },
}
</script>
